import { useState } from 'react';
import { StyleSheet, Pressable, ActivityIndicator, View } from 'react-native';
import { Feather } from '@expo/vector-icons';

import AppStyles from '../AppStyles';

import AppButton from './AppButton.js';
import WebTooltip from './WebTooltip.js';
import { useTranslation } from '../i18n';

export default function UpdateUserButton({ user, postUpdateAction, compact = false }) {
  const { t } = useTranslation('admin');

  const [updatingUser, setUpdatingUser] = useState(false);

  const editUser = async () => {
    /*
     * Edit user: Change password and/or role
     */

    setUpdatingUser(true);

    await postUpdateAction(user);

    setUpdatingUser(false);
  };

  if (compact) {
    const button = (
      <Pressable
        onPress={editUser}
        disabled={updatingUser || user == null}
        style={({ pressed }) => [
          styles.iconButton,
          pressed && styles.iconButtonPressed,
          (updatingUser || user == null) && styles.iconButtonDisabled,
        ]}
        accessibilityLabel={t('updateUser.saveChanges')}
        accessibilityHint={t('updateUser.saveHint')}
      >
        {updatingUser ? (
          <ActivityIndicator size="small" color={AppStyles.colorSet.brandPrimary} />
        ) : (
          <View style={styles.iconWrapper}>
            <Feather name="check" size={18} color={AppStyles.colorSet.success} />
          </View>
        )}
      </Pressable>
    );

    // Web hover tooltip (no-op on native)
    return <WebTooltip label={t('updateUser.saveChanges')}>{button}</WebTooltip>;
  }

  return (
    <AppButton
      title={t('updateUser.update')}
      isBusy={updatingUser}
      isEnabled={!updatingUser && user != null}
      onPress={editUser}
      buttonStyle={styles.button}
      textStyle={styles.buttonText}
    />
  );
}
const styles = StyleSheet.create({
  button: {
    cursor: 'pointer',
    marginVertical: 10,
    borderRadius: AppStyles.borderRadii.md,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 5,
    width: 70,
    backgroundColor: AppStyles.colorSet.brandPrimary,
  },
  buttonText: {
    fontSize: 12,
    fontWeight: '600',
  },
  iconButton: {
    padding: AppStyles.spacing.sm,
    borderRadius: AppStyles.borderRadii.sm,
    backgroundColor: AppStyles.colorSet.successLight,
    cursor: 'pointer',
  },
  iconButtonPressed: {
    backgroundColor: '#D1FAE5', // Slightly darker success light
  },
  iconButtonDisabled: {
    opacity: 0.5,
  },
  iconWrapper: {
    width: 18,
    height: 18,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
